import { signOut } from "next-auth/client";
// import Footer from "./footer";
import Image from "next/image";

import Footer from "@components/Footer";

import GreenLogo from "../../../public/img/green-logo-2.png";

import Touch from "../../../public/img/Boehringer_Standalone_Touch_RGB_Accent-Green.png";

type CProps = {
  title: string;
  texts: string[];
};

const VeevaBody: React.FC<CProps> = ({ title, texts }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <header className="bg-bi-green-deep-teal-950 h-16 border-b border-bi-green-deep-teal-900 relative xl:flex space-x-2 items-center justify-between hidden px-12">
        <Image src={GreenLogo} alt="" className="h-auto w-24" />

        <div className="flex h-full items-center justify-center">
          <Image src={Touch} alt="" className="h-auto w-10" />
          <span className="text-bi-green-logo text-2xl">Click</span>
        </div>
      </header>

      <main className="flex-grow py-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="border-l-4 border-bi-green-deep-teal-600 pl-4 mb-8">
            <h1 className="text-3xl font-bold text-gray-800">{title}</h1>
          </div>

          <div className="space-y-6">
            {texts.map((text, index) => (
              <p
                key={index}
                className="text-gray-600 text-lg"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            ))}
          </div>

          <div className="mt-12 pt-6 border-t border-gray-200">
            <button
              onClick={() => signOut({ callbackUrl: "/" })}
              className="inline-flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-bi-green-deep-teal-600 hover:bg-bi-green-deep-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bi-green-deep-teal-500 transition-colors duration-200"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M3 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V7.414a1 1 0 00-.293-.707L11.414 2.414A1 1 0 0010.707 2H4a1 1 0 00-1 1zm9 2.414L15.586 7H12V5.414z"
                  clipRule="evenodd"
                />
              </svg>
              Logout
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default VeevaBody;
